module.exports = __webpack_public_path__ + "static/media/yt.42419c86.svg";